module.exports = __webpack_public_path__ + "static/media/saha@3x.351b9eb9.png";